import { get } from './apiUtil';
import { AxiosResponse } from 'axios';

export function getTerritories(): Promise<string[]> {
  return new Promise((resolve, reject) => {
    get('/api/eaus/v1/processing-lab/territories')
      .then((response: AxiosResponse) => resolve(response.data))
      .catch((e) => reject(e));
  });
}
